import { ActionsObservable } from 'redux-observable';
import { Store } from 'redux';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/observable/from';
import 'rxjs/add/observable/forkJoin';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/takeUntil';
import 'rxjs/add/operator/merge';
import 'rxjs/add/operator/delay';
import {
  SortMessageRequest,
  sortMessagesSuccess,
  sortMessagesInMemory,
  AppAction,
  CategorySortMessageRequest,
  categorySortMessagesInMemory,
  categorySortMessagesSuccess,
} from '../actions';
import {
  SORT_MESSAGES_REQUEST,
  SORT_MESSAGES_CANCEL_PREV_REQUEST,
  CATEGORY_ALL,
  CATEGORY_SORT_MESSAGES_REQUEST,
} from '../constants';
import { Message, AppState, MessageCategory, Messages } from '../models';
import { AjaxCreationMethod } from 'rxjs/observable/dom/AjaxObservable';
import { arrayMove } from 'react-sortable-hoc';
import { getCannedMessageEndpoint } from '../configs';
import * as epicCommon from './epicCommon';
const concurrentRequestLimit = 5;

const getRequestBody =
  (index: number,
   action: SortMessageRequest,
   message: Message,
   messageCategory: MessageCategory | undefined) => {

    if (action.categoryName && messageCategory) {
      const attributes = message.categories || [];
      const attr = attributes.find(a => a.id === messageCategory.id);

      if (attr) {
        attr.displayOrder = index;
      } else {
        attributes.push({
          id: messageCategory!.id,
          displayOrder: index,
        });
      }
      return { categories: [...attributes] };

    }
    return { displayOrder: index };
  };

// TODO create new API for updating sort orders
export const sortMessages =
  (action$: ActionsObservable<AppAction>,
   store: Store<AppState>,
   ajax: AjaxCreationMethod): Observable<AppAction> => {

    return action$.ofType(SORT_MESSAGES_REQUEST)
      .mergeMap((request: SortMessageRequest) => {
        const state = store.getState();
   
        const messageCategory = state.messageState.messageCategories
          .find(mc => mc.categoryName === request.categoryName);

        let messages: Messages;
        let sortedMessages: Messages;
        if (messageCategory) {
          messages = messageCategory.messages;
        
          sortedMessages = [...arrayMove(messages, request.oldIndex, request.newIndex)];
          sortedMessages.forEach((m: Message, index: number) => {

            const categoryAttribute = m.categories
              .find(c => c.id === messageCategory.id);
            if (categoryAttribute) {
              categoryAttribute.displayOrder = index;
            }
          });
        }else if (request.categoryName === CATEGORY_ALL) {
          messages = state.messageState._messages;
          sortedMessages = [...arrayMove(messages, request.oldIndex, request.newIndex)];
          sortedMessages.forEach((m: Message, index: number) => {
            m.displayOrder = index;
          });
       
        }else {
          return [];
        }
        
        store.dispatch(sortMessagesInMemory(sortedMessages, request.categoryName));
    

        const endpoint = getCannedMessageEndpoint() + 'canned-messages/';
       
        const c = Observable.from(sortedMessages)
          .flatMap((message: Message, index: number) => {
            const url = `${endpoint}${message.id}`;
            const body = getRequestBody(index, request, message, messageCategory);
            return ajax.patch(url, body, epicCommon.getHttpHeaders(state.authState.authToken))
              .takeUntil(action$.ofType(SORT_MESSAGES_CANCEL_PREV_REQUEST));
          },
                   null as any, concurrentRequestLimit)
          .takeUntil(action$.ofType(SORT_MESSAGES_CANCEL_PREV_REQUEST));

        return Observable.
          forkJoin(c).map(() => sortMessagesSuccess());
      });

  };

const getCategoryRequestBody =
  (index: number, request: CategorySortMessageRequest, messageCategory: MessageCategory) => {
    return {
      id: messageCategory.id,
      name: messageCategory.categoryName,
      displayOrder: index,
      isDisabled: false,
    };
  };

export const categorySortMessages =
  (action$: ActionsObservable<AppAction>,
   store: Store<AppState>,
   ajax: AjaxCreationMethod): Observable<AppAction> => {

    return action$.ofType(CATEGORY_SORT_MESSAGES_REQUEST)
      .mergeMap((request: CategorySortMessageRequest) => {
        const state = store.getState();
        const sortedMessageCategories =
          [...arrayMove(state.messageState.messageCategories,
                        request.oldIndex, request.newIndex)];
        const endpoint = getCannedMessageEndpoint() + 'canned-message-category';

        store.dispatch(categorySortMessagesInMemory(sortedMessageCategories));
        const c = Observable.from(sortedMessageCategories)
          .flatMap((messageCategory: MessageCategory, index: number) => {
            const body = getCategoryRequestBody(index, request, messageCategory);
            return ajax.put(endpoint, body, epicCommon.getHttpHeaders(state.authState.authToken));
          },       null as any, concurrentRequestLimit);


        return Observable.
          forkJoin(c).map(() => categorySortMessagesSuccess());
      });

  };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/epics/sortMessages.ts